import type { ReactNode } from 'react'
import { useCopy } from '../../content'
import { Header } from './Header'
import { Footer } from './Footer'

/**
 * Page chrome shared by every route: skip link (first focusable element on
 * the page, targets the pages' `<main id="main">`), the fixed header, the
 * routed page, the footer.
 */
export function SiteFrame({ children }: { children: ReactNode }) {
  const copy = useCopy()
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-[60] focus:bg-vc2-paper focus:px-3 focus:py-2"
      >
        {copy.a11y.skipToContent}
      </a>
      <Header />
      {children}
      <Footer />
    </>
  )
}
